import { Row } from 'antd'
import { Tabs } from 'antd-v4'
import { autorun } from 'mobx'
import { inject } from 'mobx-react'
import React, { FC, useEffect, useState } from 'react'
import Helmet from 'react-helmet'
import { FeatureDisabledResult } from '../../../../components/FeatureDisabledResult'
import { LoadingAnimation } from '../../../../components/LoadingAnimation'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { CurrentUserStore } from '../../../../stores/CurrentUserStore'
import { DevicePage } from './DevicePage'
import { DigitalSignageProvider } from './DigitalSignageContext'
import { SignagePage } from './SignagePage'

interface IDigitalSignageSettingsProps {
  currentCompanyStore?: CurrentCompanyStore
  currentUserStore?: CurrentUserStore
}

export const DigitalSignageSettings: FC<IDigitalSignageSettingsProps> = inject(
  'currentCompanyStore',
)(({ currentCompanyStore }) => {
  const [featureIsEnabled, setFeatureIsEnabled] = useState<boolean | null>(null)

  useEffect(
    () =>
      autorun(() => {
        if (typeof currentCompanyStore?.canViewDigitalSignage === 'boolean') {
          setFeatureIsEnabled(currentCompanyStore?.canViewDigitalSignage)
        }
      }),
    [],
  )

  return featureIsEnabled === null ? (
    <LoadingAnimation />
  ) : !featureIsEnabled ? (
    <FeatureDisabledResult />
  ) : (
    <DigitalSignageProvider>
      <Row className='white-rounded-container'>
        <Helmet>
          <title>Settings | Digital Signage</title>
          <meta name='page-loaded' content='true' />
        </Helmet>

        <Tabs defaultActiveKey='1'>
          <Tabs.TabPane tab='Manage Devices' key='1'>
            <DevicePage />
          </Tabs.TabPane>
          <Tabs.TabPane tab='Manage Signage' key='2'>
            <SignagePage />
          </Tabs.TabPane>
        </Tabs>
      </Row>
    </DigitalSignageProvider>
  )
})
